import { FAQProps } from "_components/FAQs/FAQs";

export const toolsFinancingFAQs: FAQProps["items"] = [
  {
    title: "What is the Laborhack Tool Financing Product?",
    body: "The LaborHack Tool Financing Product helps you access high-quality tools for your work. Simply make a minimum deposit of 20% and repay the loan over 3 to 6 months with a 3% APR.",
  },
  {
    title: "What are the eligibility criteria, and what tools can I finance?",
    body: "You must be a registered LaborHack Pro to be eligible and you can only finance tools relevant to your trade, including power tools, hand tools, safety equipment, and more.",
  },
  {
    title: "What are the repayment terms?",
    body: "You can repay the loan over a period of 1 to 6 months, depending on your preference and financial capacity with a 3% APR.",
  },
  {
    title: "Can I apply for financing online?",
    body: "Yes, you can apply for tool financing directly through the LaborHack platform.",
  },
  {
    title: "How long does it take to get approved?",
    body: "Approval times vary, but most applications are reviewed within 48-72 hours.",
  },
  {
    title: "What happens if I miss a repayment?",
    body: "Missing a repayment will result in penalties or additional fees. It's important to contact LaborHack immediately to discuss options if you're struggling with repayment.",
  },
  {
    title: "Can I return tools financed through this program?",
    body: "Returns depend on the supplier's policy. LaborHack can assist with initiating the return process if necessary.",
  },
];
